import defineMessages from "../../../../common/helpers/defineMessages";

const messages = defineMessages({
    help: {
        id: "intro.help",
    },
});

export default messages;
